import { render, staticRenderFns } from "./CulturesPieChart.vue?vue&type=template&id=c731147c&scoped=true"
import script from "./CulturesPieChart.vue?vue&type=script&lang=js"
export * from "./CulturesPieChart.vue?vue&type=script&lang=js"
import style0 from "./CulturesPieChart.vue?vue&type=style&index=0&id=c731147c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c731147c",
  null
  
)

export default component.exports